<div class="header">
  @switch (tag) {
    @case ('h1') {
      <h1>
        <ng-container *ngTemplateOutlet="internalHeader"></ng-container>
      </h1>
    }
    @case ('h2') {
      <h2>
        <ng-container *ngTemplateOutlet="internalHeader"></ng-container>
      </h2>
    }
    @case ('h3') {
      <h3>
        <ng-container *ngTemplateOutlet="internalHeader"></ng-container>
      </h3>
    }
    @case ('h4') {
      <h4>
        <ng-container *ngTemplateOutlet="internalHeader"></ng-container>
      </h4>
    }
    @case ('h5') {
      <h5>
        <ng-container *ngTemplateOutlet="internalHeader"></ng-container>
      </h5>
    }
    @case ('h6') {
      <h6>
        <ng-container *ngTemplateOutlet="internalHeader"></ng-container>
      </h6>
    }
    @default {
      <div>
        <ng-container *ngTemplateOutlet="internalHeader"></ng-container>
      </div>
    }
  }
</div>

<ng-template #internalHeader>
  {{ label }}
  <ng-content></ng-content>
  @if (underline) {
    <hr />
  }
</ng-template>
